module.exports = __webpack_public_path__ + "static/media/logo-apple.b2c62065.svg";